/* Shy Sprout Studio — Shopify theme JS (vanilla, no build step) */
(function () {
  "use strict";

  /* ---------------------------------------------------- ambient motion */
  function initLeaves() {
    document.querySelectorAll("[data-leaffield]").forEach(function (field) {
      if (field.dataset.built) return;
      field.dataset.built = "1";
      var count = parseInt(field.dataset.count, 10) || 6;
      var hues = [118, 96, 138, 78, 52];
      for (var i = 0; i < count; i++) {
        var leaf = document.createElement("span");
        leaf.className = "leaffield__leaf leaffield__leaf--" + (i % 2);
        leaf.style.left = Math.round((i / count) * 100 + (Math.random() * 8 - 4)) + "%";
        leaf.style.animationDelay = "-" + (Math.random() * 14).toFixed(2) + "s";
        leaf.style.animationDuration = (15 + Math.random() * 14).toFixed(2) + "s";
        leaf.style.setProperty("--lf-scale", (0.6 + Math.random() * 0.8).toFixed(2));
        leaf.style.setProperty("--lf-hue", hues[i % 5]);
        field.appendChild(leaf);
      }
    });
  }

  function spawnBurst(x, y) {
    var root = document.createElement("div");
    root.className = "burst";
    root.style.left = x + "px";
    root.style.top = y + "px";
    var hues = [118, 96, 138, 78];
    for (var i = 0; i < 7; i++) {
      var s = document.createElement("span");
      var ang = (Math.PI * 2 * i) / 7 + Math.random() * 0.6;
      var dist = 46 + Math.random() * 40;
      s.style.setProperty("--bx", Math.cos(ang) * dist + "px");
      s.style.setProperty("--by", Math.sin(ang) * dist - 30 + "px");
      s.style.setProperty("--br", Math.round(Math.random() * 540 - 270) + "deg");
      s.style.background = "linear-gradient(160deg, hsl(" + hues[i % 4] + " 50% 62%), var(--leaf))";
      root.appendChild(s);
    }
    document.body.appendChild(root);
    setTimeout(function () { root.remove(); }, 900);
  }

  /* ------------------------------------------------------- cart count */
  function bump(el) {
    if (!el) return;
    el.classList.remove("bump");
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add("bump"); }); });
  }

  function refreshCartCount() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count || 0;
        var headerEl = document.querySelector("[data-cart-quantity]");
        var badgeEl = document.querySelector("[data-cart-badge]");
        if (headerEl) { headerEl.textContent = n; bump(headerEl); }
        if (badgeEl) { badgeEl.textContent = n; badgeEl.hidden = n <= 0; if (n > 0) bump(badgeEl); }
        return cart;
      })
      .catch(function () {});
  }

  function cartAdd(id, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: id, quantity: quantity || 1 }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function cartChange(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) { return r.json(); });
  }

  /* --------------------------------------------------- quick add (cards) */
  function initQuickAdd() {
    document.querySelectorAll("[data-quick-add]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = btn.getAttribute("data-variant-id");
        var url = btn.getAttribute("data-product-url");
        if (!id) { if (url) window.location = url; return; }
        cartAdd(id, 1)
          .then(function () { spawnBurst(e.clientX, e.clientY); refreshCartCount(); })
          .catch(function () { if (url) window.location = url; }); // needs variant choice → PDP
      });
    });
  }

  /* ----------------------------------------------- product detail page */
  function initPdp() {
    var main = document.getElementById("pdp-main");
    document.querySelectorAll(".pdp__thumb[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        if (main) main.src = t.getAttribute("data-thumb");
        document.querySelectorAll(".pdp__thumb").forEach(function (x) { x.classList.remove("on"); });
        t.classList.add("on");
      });
    });

    var qty = document.querySelector("[data-qty-input]");
    var dec = document.querySelector("[data-qty-dec]");
    var inc = document.querySelector("[data-qty-inc]");
    if (qty && dec && inc) {
      dec.addEventListener("click", function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      inc.addEventListener("click", function () { qty.value = Math.min(99, (parseInt(qty.value, 10) || 1) + 1); });
    }

    // variant select → live price
    var sel = document.querySelector("[data-variant-select]");
    var priceEl = document.querySelector("[data-price]");
    if (sel && priceEl) {
      sel.addEventListener("change", function () {
        var opt = sel.options[sel.selectedIndex];
        if (opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      });
    }

    var form = document.querySelector(".pdp__form");
    var toast = document.querySelector("[data-add-toast]");
    var msg = document.querySelector("[data-add-msg]");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var idField = form.querySelector('[name="id"]');
        var qtyField = form.querySelector('[name="quantity"]');
        var id = idField ? idField.value : null;
        var quantity = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
        if (!id) return;
        cartAdd(id, quantity)
          .then(function () {
            spawnBurst(window.innerWidth / 2, window.innerHeight / 2);
            refreshCartCount();
            if (toast) { toast.classList.add("show"); setTimeout(function () { toast.classList.remove("show"); }, 2600); }
          })
          .catch(function (err) {
            if (msg) { msg.hidden = false; msg.textContent = (err && err.description) || "Sorry, that couldn't be added."; }
          });
      });
    }
  }

  /* ---------------------------------------------------------- cart page */
  function initCartPage() {
    function change(key, q) { cartChange(key, q).then(function () { window.location.reload(); }); }
    document.querySelectorAll("[data-cart-inc]").forEach(function (b) {
      b.addEventListener("click", function () { change(b.getAttribute("data-key"), (parseInt(b.getAttribute("data-qty"), 10) || 1) + 1); });
    });
    document.querySelectorAll("[data-cart-dec]").forEach(function (b) {
      b.addEventListener("click", function () { change(b.getAttribute("data-key"), (parseInt(b.getAttribute("data-qty"), 10) || 1) - 1); });
    });
    document.querySelectorAll("[data-cart-remove]").forEach(function (b) {
      b.addEventListener("click", function () { change(b.getAttribute("data-key"), 0); });
    });
  }

  /* ----------------------------------------- free-shipping progress bar */
  function initShipBar() {
    var s = document.querySelector("[data-cart-summary]");
    if (!s) return;
    var sub = parseFloat(s.dataset.subtotal) || 0;
    var thr = parseFloat(s.dataset.threshold) || 35;
    var bar = s.querySelector("[data-ship-bar]");
    if (bar) bar.style.width = Math.min(100, Math.round((sub / thr) * 100)) + "%";
    var note = s.querySelector("[data-ship-note]");
    if (note) {
      note.innerHTML = sub >= thr
        ? "<b>Free shipping</b> unlocked 🌿"
        : "Add <b>$" + Math.max(0, thr - sub).toFixed(2) + "</b> more for free shipping";
    }
  }

  function init() {
    initLeaves();
    refreshCartCount();
    initQuickAdd();
    initPdp();
    initCartPage();
    initShipBar();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
